import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['cancelReasonTextWrapper'];

  connect() {
    console.log("ptdr4")
    this.handleAccordionToggle = this.handleAccordionToggle.bind(this);
    document.addEventListener('accordion:toggled', this.handleAccordionToggle);
  }

  disconnect() {
    document.removeEventListener('accordion:toggled', this.handleAccordionToggle);
  }

  handleAccordionToggle(event) {
    let accordionTogglerElem = event.target.querySelector('.accordion__toggler .accordion__toggler_div')
    let closeHandle = accordionTogglerElem.querySelector('.icon-handle-close')
    let openHandle = accordionTogglerElem.querySelector('.icon-handle-open')

    if (event.detail.isOpening) {
      accordionTogglerElem.classList.add('!bg-brand-secondary', '!border-transparent', '!rounded-b-none');
      closeHandle.classList.add('hidden');
      openHandle.classList.remove('hidden');
    } else {
      accordionTogglerElem.classList.remove('!bg-brand-secondary', '!border-transparent', '!rounded-b-none');
      openHandle.classList.add('hidden');
      closeHandle.classList.remove('hidden');
    }
  }

  handleSelectCancelReason(e) {
    let elem = e.currentTarget
    if (elem.value == 'other') {
      this.cancelReasonTextWrapperTarget.classList.remove('hidden');
    } else if (!this.cancelReasonTextWrapperTarget.classList.contains('hidden')) {
      this.cancelReasonTextWrapperTarget.classList.add('hidden');
    }
  }
}
